import React from 'react'
import Nav from './Nav';

export const Order = () => {
  return (
    <>
    <Nav/>
    <div className='order-wrapper'>

 
    <div className='order'>
      <h4>Order Received Click on this to Proceed to Payment</h4>
      <img src='/asset/payments.png'/> <br/>
      <button>Make Payment </button>
      </div>
       </div>
       </>
  )
}
